import React, { useState } from 'react'
import PropTypes from 'prop-types'
import useStyles from './image-viewer.style'

import Lightbox from 'react-image-lightbox'

import 'react-image-lightbox/style.css'

const ImageViewer = (props) => {
  const { children } = props
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const handleOnClick = () => setIsOpen(true)
  const handleOnCloseRequest = () => setIsOpen(!isOpen)

  return (
    <div
      className={classes.baseImageViewer}
      onClick={handleOnClick}
    >
      {children}
      {isOpen && <Lightbox
        mainSrc={children?.props?.src}
        onCloseRequest={handleOnCloseRequest}
      />}
    </div>
  )
}

ImageViewer.defaultProps = {
  children: null
}

ImageViewer.propTypes = {
  children: PropTypes.shape({})
}

export default ImageViewer
